import { useAuthorizationStore } from '#stores/useAuthStore.js'

const authRoutes = [
	{
		name: 'auth.login',
		path: '/login', // ?token=abc redirects to /login-token?token=abc to keep the old mail setup
		meta: { layout: 'auth', requiresLogout: true },
		component: () => import('#modules/auth/pages/LoginPage.vue'),
		beforeEnter: (to, from, next) => {
			const auth = useAuthorizationStore()
			if (auth.isSessionActive()) {
				next({ name: 'app.start' })
			} else {
				next()
			}
		},
	},
	{
		name: 'auth.sso-result',
		path: '/auth/sso/result',
		children: [
			{
				name: 'auth.sso-result-unknown-user',
				path: 'unknown-user',
				meta: { layout: 'auth' },
				component: () => import('#modules/auth/pages/SSO/UnknownUser.vue'),
			},
			{
				name: 'auth.sso-result-multiple-users',
				path: 'multiple-users',
				meta: { layout: 'auth' },
				component: () => import('#modules/auth/pages/SSO/MultipleUsers.vue'),
			},
			{
				name: 'auth.sso-sso-mismatch',
				path: 'sso-mismatch',
				meta: { layout: 'auth' },
				component: () => import('#modules/auth/pages/SSO/SingleSignonMismatch.vue'),
			},
			{
				name: 'auth.sso-invalid-state',
				path: 'invalid-state',
				meta: { layout: 'auth' },
				component: () => import('#modules/auth/pages/SSO/InvalidState.vue'),
			},
			{
				name: 'auth.sso-unknown-error',
				path: 'unknown-error',
				meta: { layout: 'auth' },
				component: () => import('#modules/auth/pages/SSO/UnknownError.vue'),
			},
			{
				name: 'auth.sso-valid',
				path: 'valid/:userId/:token',
				meta: { layout: 'auth' },
				component: () => import('#modules/auth/pages/SSO/Valid.vue'),
			},
		],
	},
	{
		name: 'auth.logout', // logs out and redirects to auth.login
		path: '/logout',
		meta: { layout: 'none' },
		component: () => import('#modules/auth/pages/LogoutPage.vue'),
	},
	{
		name: 'auth.register',
		path: '/register/:id([a-zA-Z0-9]+)',
		meta: { layout: 'auth', requiresLogout: true },
		component: () => import('#modules/auth/pages/RegisterPage.vue'),
	},
	{
		name: 'auth.forgot',
		path: '/forgot',
		meta: { layout: 'auth', requiresLogout: true },
		component: () => import('#modules/auth/pages/ForgotPassword.vue'),
	},
	{
		name: 'auth.newPassword',
		path: '/password/new',
		meta: { layout: 'auth', requiresLogout: true },
		component: () => import('#modules/auth/pages/ChangePassword.vue'),
	},
]

export default authRoutes
